import MultiValue from '../MultipleSelect/MultiValue';

type ContactOption = {
  label: string;
  value?: any;
  icon?: any;
  automated?: boolean;
  extraData?:
    | {
        type: 'list';
        contactsCount: number;
      }
    | {
        type: 'contact';
        email: string;
        avatar: string;
      }
    | {
        type: 'email';
        email: string;
      }
    | Record<string, never>;
};

const ContactMultiValue = (props: { data: ContactOption }) => {
  const { data } = props;
  if (!data.extraData) return <div />;
  const name =
    data.extraData.type === 'list' ? `${data.label} (${data.extraData.contactsCount})` : data.label;
  return (
    <MultiValue
      {...(props as any)}
      data={{
        label: name,
        value: data.value,
        icon: data.icon,
        automated: data.automated,
      }}
    />
  );
};

ContactMultiValue.displayName = 'ContactMultiValue';

export default ContactMultiValue;
